import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Checkbox as CheckboxView, useCheckbox } from '.';
import { WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
import { wrap } from '@atlasgroup/react-wrap';
export const Checkbox = wrap(CheckboxView, useCheckbox);
export const _frontmatter = {};
const layoutProps = {
  Checkbox,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h1>
    <p>{`Better looking alternative to native HTML checkbox`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { Checkbox as CheckboxView, useCheckbox } from '@atlasgroup/react-atlantic';

const Checkbox = wrap(CheckboxView, useCheckbox);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`Checkbox`}</inlineCode>{` must be wrapped with `}<inlineCode parentName="p">{`useCheckbox`}</inlineCode>{` to make the element interactive. But be aware `}<inlineCode parentName="p">{`useCheckbox`}</inlineCode>{` hook provides basic checkbox logic only such as handling `}<inlineCode parentName="p">{`isChecked`}</inlineCode>{` prop, for more info see `}<a parentName="p" {...{
          "href": "#known-bugs"
        }}>{`known bugs section`}</a></p>
    </blockquote>
    <Playground __position={0} __code={'<Checkbox>Check ME</Checkbox>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CheckboxView,
      useCheckbox,
      WrapperHorizontal,
      wrap,
      DefaultLayout,
      Checkbox,
      _frontmatter
    }} mdxType="Playground">
    <Checkbox mdxType="Checkbox">Check ME</Checkbox>
    </Playground>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<CheckboxView size=\"small\">Check ME</CheckboxView>\n<CheckboxView size=\"medium\">Check ME</CheckboxView>\n<CheckboxView size=\"large\">Check ME</CheckboxView>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CheckboxView,
      useCheckbox,
      WrapperHorizontal,
      wrap,
      DefaultLayout,
      Checkbox,
      _frontmatter
    }} mdxType="Playground">
    <CheckboxView size="small" mdxType="CheckboxView">Check ME</CheckboxView>
    <CheckboxView size="medium" mdxType="CheckboxView">Check ME</CheckboxView>
    <CheckboxView size="large" mdxType="CheckboxView">Check ME</CheckboxView>
    </Playground>
    <h2 {...{
      "id": "other-props"
    }}>{`Other props`}</h2>
    <Playground __position={2} __code={'<Checkbox isDefaultChecked>Check ME</Checkbox>\n<Checkbox isDisabled>Check ME</Checkbox>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CheckboxView,
      useCheckbox,
      WrapperHorizontal,
      wrap,
      DefaultLayout,
      Checkbox,
      _frontmatter
    }} mdxType="Playground">
    <Checkbox isDefaultChecked mdxType="Checkbox">Check ME</Checkbox>
    <Checkbox isDisabled mdxType="Checkbox">Check ME</Checkbox>
    </Playground>
    <h2 {...{
      "id": "text-positions"
    }}>{`Text positions`}</h2>
    <Playground __position={3} __code={'<WrapperHorizontal>\n  <CheckboxView horizontalPosition=\"left\">Check ME</CheckboxView>\n  <CheckboxView horizontalPosition=\"right\">Check ME</CheckboxView>\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CheckboxView,
      useCheckbox,
      WrapperHorizontal,
      wrap,
      DefaultLayout,
      Checkbox,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <CheckboxView horizontalPosition="left" mdxType="CheckboxView">Check ME</CheckboxView>
        <CheckboxView horizontalPosition="right" mdxType="CheckboxView">Check ME</CheckboxView>
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "known-bugs"
    }}>{`Known bugs`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`useCheckbox`}</inlineCode>{` hook does not handle correctly `}<inlineCode parentName="li">{`isPartiallyChecked`}</inlineCode>{` prop`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`useCheckbox`}</inlineCode>{` hook does not pass props (e.g. `}<inlineCode parentName="li">{`size`}</inlineCode>{`, `}<inlineCode parentName="li">{`horizontalPosition`}</inlineCode>{`, ...)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`CheckboxView`}</inlineCode>{` can not have `}<inlineCode parentName="li">{`isPartiallyChecked`}</inlineCode>{` and `}<inlineCode parentName="li">{`isChecked`}</inlineCode>{` prop at the same time`}</li>
    </ul>
    <Playground __position={4} __code={'<Checkbox isPartiallyChecked>Check ME</Checkbox>\n<CheckboxView isPartiallyChecked isChecked>\n  Check ME\n</CheckboxView>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CheckboxView,
      useCheckbox,
      WrapperHorizontal,
      wrap,
      DefaultLayout,
      Checkbox,
      _frontmatter
    }} mdxType="Playground">
    <Checkbox isPartiallyChecked mdxType="Checkbox">Check ME</Checkbox>
    <CheckboxView isPartiallyChecked isChecked mdxType="CheckboxView">
        Check ME
    </CheckboxView>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      